import React, { useState, useEffect } from 'react';

interface TeamMember {
  id: number;
  name: string;
  img: string;
  post?: string;
  social: Array<{
    icon: string;
    url: string;
    title: string;
  }>;
}

interface ReviewBoardSectionProps {
  className?: string;
  title: string;
  jsonFileName: string;
}

const ReviewBoardSection: React.FC<ReviewBoardSectionProps> = ({ className, title, jsonFileName }) => {
  const [reviewBoardMembers, setReviewBoardMembers] = useState<TeamMember[]>([]);

  useEffect(() => {
    const loadReviewBoardData = async () => {
      try {
        const response = await fetch(`/json/${jsonFileName}`);
        if (response.ok) {
          const members: TeamMember[] = await response.json();
          setReviewBoardMembers(members);
        }
      } catch (error) {
        console.warn(`Failed to load ${title} data:`, error);
      }
    };

    loadReviewBoardData();
  }, [title, jsonFileName]);

  const renderTeamMember = (member: TeamMember) => (
    <div className="review-board-card" key={member.id} tabIndex={0} aria-label={`${member.name} profile`}>
      <div className="review-board-image-container">
        <img 
          src={member.img} 
          alt={member.name}
          onError={(e) => {
            // Fallback to initials if image fails to load
            const img = e.target as HTMLImageElement;
            img.style.display = 'none';
            const initialsContainer = img.nextElementSibling as HTMLElement;
            if (initialsContainer) {
              initialsContainer.style.display = 'flex';
            }
          }}
        />
        <div className="review-board-initials" style={{ 
          width: '100%', 
          height: '100%', 
          backgroundColor: '#f0f0f0', 
          color: '#666', 
          fontSize: '24px', 
          display: 'none', 
          alignItems: 'center', 
          justifyContent: 'center'
        }}>
          {member.name.split(' ').map(n => n[0]).join('')}
        </div>
      </div>
      <div className="review-board-name">{member.name}</div>
    </div>
  );

  return (
    <section className={`review-board-section ${className || ''}`}>
      <h3>{title}</h3>
      <div className="review-board-carousel" role="list">
        {reviewBoardMembers.length > 0 ? (
          reviewBoardMembers.map(renderTeamMember)
        ) : (
          <div className="review-board-card" style={{ textAlign: 'center', padding: '20px' }}>
            <p>Loading {title.toLowerCase()} information...</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ReviewBoardSection;
